import { createAction, props } from '@ngrx/store';

export enum ForesiteXdActionType {
    FORESITE_XD_SENSOR_CHANGE = '@form/FORESITE_XD_SENSOR_CHANGE',
    FORESITE_XD_MAX_RANGE_CHANGE = '@form/FORESITE_XD_MAX_RANGE_CHANGE',
}

export const foresiteXdSensorChange = createAction(
    ForesiteXdActionType.FORESITE_XD_SENSOR_CHANGE,
    props<{ sensorValue: string }>(),
);

export const foresiteXdMaxRangeChange = createAction(
    ForesiteXdActionType.FORESITE_XD_MAX_RANGE_CHANGE,
    props<{ value: number }>(),
);
